export const TermsAndConditionsText = `

1. At least 80% Deposit required upon approval.
2. Balance payment is required before  vehicle can be released to the customer
3. Hidden Fault not Covered.
4. Vehicle parked within AYDENS Garage without approval will attract a daily charge of N2,500.
5. AYDENS garage shall not be held liable for all transportation and/or other incidental costs the customer may incur whilst the vehicle is being repaired or in any obligation to provide a courtesy vehicle during this period.

TIN: 313422177-001 | RC: 697295
`;
